export default function Creator() {
  return (
    <section className="py-24 bg-gray-50">
      <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
        <div className="mb-8">
          <div className="w-40 h-40 mx-auto rounded-full bg-gradient-to-br from-teal-400 to-blue-500 p-1 shadow-xl">
            <img 
              src="https://static.readdy.ai/image/6006b18c50b98974f62513d00886a423/7135bcec3c75d7254f1439a31b133be3.jpeg"
              alt="Sarthak Bobade"
              className="w-full h-full rounded-full object-cover"
            />
          </div>
          <div className="w-32 h-1 bg-teal-600 mx-auto mt-8 rounded-full"></div>
        </div>

        <h2 className="text-4xl font-bold text-gray-900 mb-2">Sarthak Bobade</h2>
        <p className="text-xl text-teal-600 font-semibold mb-8">Data Scientist & Creator</p>

        <p className="text-lg text-gray-700 leading-relaxed mb-10 max-w-3xl mx-auto">
          Creator of MomsFirstCare, focused on applying AI, analytics, and real-world data to solve healthcare challenges and improve maternal & child health outcomes. Passionate about leveraging technology to make healthcare more transparent, accessible, and data-driven for families across India.
        </p>

        <div className="flex flex-wrap justify-center gap-4">
          <a
            href="https://www.linkedin.com/in/sarthak-bobade-2029ya/"
            target="_blank"
            rel="noopener noreferrer"
            className="px-8 py-3 border-2 border-gray-900 text-gray-900 rounded-full font-semibold hover:bg-gray-900 hover:text-white transition-all inline-flex items-center gap-2 whitespace-nowrap"
          >
            <i className="ri-linkedin-fill text-xl"></i>
            LinkedIn
          </a>
          <a
            href="#"
            className="px-8 py-3 border-2 border-gray-900 text-gray-900 rounded-full font-semibold hover:bg-gray-900 hover:text-white transition-all inline-flex items-center gap-2 whitespace-nowrap"
          >
            <i className="ri-briefcase-line text-xl"></i>
            Portfolio
          </a>
        </div>

        <div className="mt-16 p-8 bg-gradient-to-r from-teal-50 to-blue-50 rounded-2xl">
          <p className="text-base text-gray-700 italic">
            Data has the power to transform healthcare. By making information accessible and actionable, we can help families make better decisions and improve health outcomes for mothers and children everywhere.
          </p>
        </div>
      </div>
    </section>
  );
}
